// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dK7GJj__frgtrDrXUZ4i {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  flex-wrap: wrap;
  background-color: var(--xds-color-white);
  border-bottom: 1px solid var(--xds-color-charcoal-30);
  padding: 30px 34px;
}

@media (max-width: 600px) {
  .LUeL1SVOaejm_yo4a2lU {
    border-bottom: inherit;
  }
}

.cLCA_j9ng4hTuLYF8Tfg {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.To7QV6hplpKdAidnXzsi {
  margin: 24px 0 16px;
}

.SggyiwbmkJyNICD9sKjo {
  display: inline-block;
  overflow: hidden;
}

.bC44RH87iK33Rv8LNTS_ {
  width: 100%;
  max-width: 100px;
  margin: 0px 12px;
  height: 33px;
}

.bC44RH87iK33Rv8LNTS_:hover {
  cursor: pointer;
}

.mPGgjBmKa3IAKBgQTNaL {
  width: 100%;
  max-width: 24px;
  margin-right: 10px;
}

.PC9FqRJtLiJOq9wOgCQd {
  list-style: none;
  font-size: 0.9rem;
  padding: 0;
  margin-bottom: 0;
}



.PC9FqRJtLiJOq9wOgCQd li {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
}

.PC9FqRJtLiJOq9wOgCQd li:nth-child(2) {
  display: flex;
  justify-content: center;
  width: 100%;
}

.PC9FqRJtLiJOq9wOgCQd li span {
  text-align: justify;
}`, "",{"version":3,"sources":["webpack://./src/components/EmailVerify/style.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,sBAAsB;EACtB,eAAe;EACf,wCAAwC;EACxC,qDAAqD;EACrD,kBAAkB;AACpB;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,UAAU;EACV,gBAAgB;AAClB;;;;AAIA;EACE,aAAa;EACb,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".contentWrapper {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  flex-direction: column;\n  flex-wrap: wrap;\n  background-color: var(--xds-color-white);\n  border-bottom: 1px solid var(--xds-color-charcoal-30);\n  padding: 30px 34px;\n}\n\n@media (max-width: 600px) {\n  .content {\n    border-bottom: inherit;\n  }\n}\n\n.contentHeader {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n}\n\n.contentHeaderText {\n  margin: 24px 0 16px;\n}\n\n.contentLinks {\n  display: inline-block;\n  overflow: hidden;\n}\n\n.contentImages {\n  width: 100%;\n  max-width: 100px;\n  margin: 0px 12px;\n  height: 33px;\n}\n\n.contentImages:hover {\n  cursor: pointer;\n}\n\n.contentIcons {\n  width: 100%;\n  max-width: 24px;\n  margin-right: 10px;\n}\n\n.contentList {\n  list-style: none;\n  font-size: 0.9rem;\n  padding: 0;\n  margin-bottom: 0;\n}\n\n\n\n.contentList li {\n  display: flex;\n  align-items: flex-start;\n  justify-content: flex-start;\n}\n\n.contentList li:nth-child(2) {\n  display: flex;\n  justify-content: center;\n  width: 100%;\n}\n\n.contentList li span {\n  text-align: justify;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"contentWrapper": `dK7GJj__frgtrDrXUZ4i`,
	"content": `LUeL1SVOaejm_yo4a2lU`,
	"contentHeader": `cLCA_j9ng4hTuLYF8Tfg`,
	"contentHeaderText": `To7QV6hplpKdAidnXzsi`,
	"contentLinks": `SggyiwbmkJyNICD9sKjo`,
	"contentImages": `bC44RH87iK33Rv8LNTS_`,
	"contentIcons": `mPGgjBmKa3IAKBgQTNaL`,
	"contentList": `PC9FqRJtLiJOq9wOgCQd`
};
export default ___CSS_LOADER_EXPORT___;
